import { render, staticRenderFns } from "./nivelhierarquico.vue?vue&type=template&id=64711c8a&"
import script from "./nivelhierarquico.vue?vue&type=script&lang=js&"
export * from "./nivelhierarquico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports